import { useAuth } from "../auth/AuthProvider";
import { Link } from "../components/Link";
import { confirmLeave } from "../router";

const ROLE_LABEL = {
  ADMIN: "관리자",
  TEACHER: "교사",
  STUDENT: "학생",
} as const;

/** 내 정보, 비밀번호 변경·학교 변경 진입, 로그아웃을 한곳에 모은 화면. */
export const AccountPage = () => {
  const auth = useAuth();
  if (auth.state.status !== "authenticated") {
    return null;
  }
  const { session } = auth.state;
  const { principal, studentProfile, teacherProfile } = session;

  const logout = () => {
    const proceed = () => {
      void auth.logout();
    };
    if (confirmLeave(proceed)) {
      proceed();
    }
  };

  return (
    <section className="canvaschool-auth canvaschool-account">
      <h1>마이페이지</h1>
      <section aria-labelledby="canvaschool-account-info">
        <h2 id="canvaschool-account-info">내 정보</h2>
        <dl>
          <dt>아이디</dt>
          <dd>{principal.loginId}</dd>
          <dt>역할</dt>
          <dd>{ROLE_LABEL[principal.role]}</dd>
          {principal.role === "STUDENT" && studentProfile && (
            <>
              <dt>번호</dt>
              <dd>{studentProfile.studentNumber}번</dd>
              <dt>이름</dt>
              <dd>{studentProfile.displayName ?? "미입력"}</dd>
            </>
          )}
          {principal.role === "TEACHER" && teacherProfile && (
            <>
              <dt>소속 학교</dt>
              <dd>{teacherProfile.school?.name ?? "선택 안 함"}</dd>
            </>
          )}
        </dl>
        {principal.role === "TEACHER" && teacherProfile && (
          <p>
            <Link to="/school">학교 변경</Link>
          </p>
        )}
      </section>
      {session.impersonator ? (
        <section aria-labelledby="canvaschool-account-manage">
          <h2 id="canvaschool-account-manage">계정 관리</h2>
          <p>
            관리자({session.impersonator.loginId})가 이 선생님의 화면을 보고
            있습니다. 비밀번호는 선생님 본인만 바꿀 수 있습니다.
          </p>
          <button type="button" onClick={logout}>
            관리자로 돌아가기
          </button>
        </section>
      ) : (
        <section aria-labelledby="canvaschool-account-manage">
          <h2 id="canvaschool-account-manage">계정 관리</h2>
          <p>
            <Link to="/password">비밀번호 변경</Link>
          </p>
          <p>
            이 기기에서는 로그인 후 30일 동안 자동으로 로그인됩니다. 공용
            컴퓨터라면 다 쓴 뒤 로그아웃하세요.
          </p>
          <button type="button" onClick={logout}>
            로그아웃
          </button>
        </section>
      )}
    </section>
  );
};
